import { Box, Typography } from "@mui/material";
import StraightenIcon from "@mui/icons-material/Straighten";
import "./LawnSizeEstimator.css";

const LawnSizeEstimator = ({
  label,
  areaSizes = "0",
  description = "",
  unit = "sq ft",
}: {
  label: string;
  areaSizes?: string;
  description?: string;
  unit?: string;
}) => {
  return (
    <div className="lawn-size-estimator">
      <Box className="lawn-size-header">
        <StraightenIcon />
        <Box className="lawn-size-content">
          <Typography variant="h4" margin={0}>
            {label}
          </Typography>
          <Typography variant="h1" margin={0} className="lawn-size-title">
            {areaSizes}
            <Box component="span" className="lawn-size-unit">
              {unit}
            </Box>
          </Typography>
          <Typography
            className="lawn-size-description"
            variant="body1"
            marginTop={1}
          >
            {areaSizes.length > 0 ? description : ""}
          </Typography>
        </Box>
      </Box>
    </div>
  );
};
export default LawnSizeEstimator;
